import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { OFFERINGS_PATH, ROOT_PATH } from '../constants/paths.constants';
import { USER_RESOURCE } from '../resources/user.resource';
import { authenticatedSelector } from '../selectors/auth.selectors';
import { fetchingSelector } from '../selectors/fetch.selectors';

function Home() {
  const navigate = useNavigate();
  const location = useLocation();
  const authenticated = useSelector((state) => authenticatedSelector(state, { path: location.pathname }));
  const fetchingUser = useSelector((state) => fetchingSelector(state, { resource: USER_RESOURCE }));

  useEffect(() => {
    if (location.pathname === ROOT_PATH) {
      return navigate(OFFERINGS_PATH, { replace: true });
    }
  }, [navigate, authenticated, location.pathname, fetchingUser]);

  return <Outlet />;
}

export default Home;
